/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Activity_Drag_Reopen_To_Open_OnlyInputs */

const vi_work_activity_drag_reopen_to_open_only = /** @type {(inputs: Work_Activity_Drag_Reopen_To_Open_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhiệm vụ đã đóng chỉ có thể mở lại về cột Đang mở.`)
};

/**

* @param {Work_Activity_Drag_Reopen_To_Open_OnlyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const work_activity_drag_reopen_to_open_only = /** @type {((inputs?: Work_Activity_Drag_Reopen_To_Open_OnlyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Activity_Drag_Reopen_To_Open_OnlyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_work_activity_drag_reopen_to_open_only(inputs)
});